import { ChangeDetectionStrategy, Component, type ElementRef, effect, input, model, viewChild } from '@angular/core';
import { IconoComponent } from '../icono/icono.component';

/**
 * Diálogo modal sobre <dialog> nativo: foco atrapado, Esc cierra, fondo inerte.
 *   <app-dialogo [(abierto)]="x" titulo="Cargar tasa manual"> ...contenido... <div acciones>…</div></app-dialogo>
 */
@Component({
  selector: 'app-dialogo',
  imports: [IconoComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    dialog::backdrop { background: rgb(27 16 38 / 0.45); }
    dialog { max-width: min(32rem, calc(100vw - 2rem)); }
    dialog.amplio { max-width: min(48rem, calc(100vw - 2rem)); }
  `,
  template: `
    <dialog #dialogo class="m-auto w-full rounded-2xl bg-superficie p-0 text-tinta shadow-2xl" [class.amplio]="ancho() === 'amplio'" [attr.aria-labelledby]="idTitulo" (close)="abierto.set(false)">
      <div class="flex items-start justify-between gap-4 px-6 pt-5">
        <h2 [id]="idTitulo" class="text-xl font-bold">{{ titulo() }}</h2>
        <button type="button" (click)="abierto.set(false)" class="-mr-2 grid size-9 shrink-0 place-items-center rounded-full hover:bg-lila" aria-label="Cerrar">
          <app-icono nombre="cerrar" [tamano]="20" />
        </button>
      </div>
      <div class="px-6 pb-2 pt-3"><ng-content /></div>
      <div class="flex flex-wrap justify-end gap-2 px-6 pb-5 pt-3"><ng-content select="[acciones]" /></div>
    </dialog>
  `,
})
export class DialogoComponent {
  private static siguiente = 0;
  readonly abierto = model(false);
  readonly titulo = input.required<string>();
  readonly ancho = input<'normal' | 'amplio'>('normal');
  readonly idTitulo = `dialogo-titulo-${DialogoComponent.siguiente++}`;

  private readonly dialogo = viewChild.required<ElementRef<HTMLDialogElement>>('dialogo');

  constructor() {
    effect(() => {
      const d = this.dialogo().nativeElement;
      if (this.abierto() && !d.open) d.showModal();
      if (!this.abierto() && d.open) d.close();
    });
  }
}
